import script from "./ForecastDiffLastMonthTableHead.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForecastDiffLastMonthTableHead.vue?vue&type=script&lang=ts&setup=true"

import "./ForecastDiffLastMonthTableHead.vue?vue&type=style&index=0&id=849adbd8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-849adbd8"]])

export default __exports__